// Enquiry page: video
if (document.getElementById("fullscreen-bg")) {
  if (window.matchMedia("(max-width: 750px)").matches) {
    document.getElementById("fullscreen-bg").innerHTML = '';
  } else {
    var video_URL = '../assets/img/contact-us/wli-business-trip.mp4';
    document.getElementById("fullscreen-bg").innerHTML = '<video playsinline="playsinline" autoplay="autoplay" muted="muted" loop="loop" class="lazyload fullscreen-bg__video"><source src="' + video_URL + '" type="video/mp4"></video>';
  }
}


  //Enquiry page: Current Year
  if (document.getElementById("fullscreen-bg")) {
    document.getElementById('copyrightyear1').appendChild(document.createTextNode(new Date().getFullYear()))
  }

// Enquiry page: Scroll to top
$(".btncontact").click(function () {
    $('html, body').animate({
      scrollTop: $(".contact-form-wrapper").offset().top - 20
    }, 800);
  });